export const GUIDED_INTAKE_PROMO_EVENTS = {
  DISMISSED: 'Guided Intake Promo Dismissed',
} as const
